import { Alert } from "reactstrap";

export const ErrorHandler = (props: {isOpen: boolean, toggle: () => void, message: string}) => {
  return <Alert isOpen={props.isOpen} color='danger' toggle={props.toggle} className='alert-success'>
  <p className='m-0'><span className={`k-icon k-i-close-circle`}></span> {props.message}</p>
  </Alert>
}